import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "./components/AppShell";
import { ScrollToTop } from "./components/ScrollToTop";
import { CartPage } from "./pages/CartPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import { Products } from "./pages/Products";
import { SuccessPage } from "./pages/SuccessPage";
import { initializePlatterUiStorageVersion } from "./utils/safeStorage";

function App() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    initializePlatterUiStorageVersion();
  }, []);

  return (
    <BrowserRouter basename="/platter">
      <ScrollToTop />
      <AppShell selectedCategory={selectedCategory} onSelectCategory={setSelectedCategory}>
        <Routes>
          <Route element={<Products selectedCategory={selectedCategory} />} path="/" />
          <Route element={<Products selectedCategory={selectedCategory} />} path="/products" />
          <Route element={<ProductDetailPage />} path="/products/:id" />
          <Route element={<Navigate replace to="/products" />} path="/categories" />
          <Route element={<CartPage />} path="/cart" />
          <Route element={<CheckoutPage />} path="/checkout" />
          <Route element={<SuccessPage />} path="/success" />
          <Route element={<Navigate replace to="/products" />} path="/home" />
          <Route element={<NotFoundPage />} path="*" />
        </Routes>
      </AppShell>
    </BrowserRouter>
  );
}

export default App;
